import type { DialogueItemMessage } from 'components/Dialogue/types';
import LazyItemMessage from '../LazyItemMessage';
import QuoteMessage from '../QuoteMessage';
import { useChatContext } from '../../contexts/ChatContext';
import { MessageStatusDecorate } from '../MessageStatusDecorate';
import { MessageExtend } from '../MessageExtend';
import { BaseMsgProps } from './types';
import { memo } from 'react';

export const ItemMsg = memo((props: BaseMsgProps) => {
  const { msg, raw, conversation } = props;
  const { clickQuote, dialogRef } = useChatContext();
  const { topBarInfo } = conversation;
  const { failCause } = raw;
  const dataSource = (msg as DialogueItemMessage).content;
  return (
    <LazyItemMessage
      rawMsg={msg.raw}
      storeId={conversation?.storeId || ''}
      externalItemId={`${dataSource.id}`}
      externalStoreId={msg.raw.itemContent?.externalStoreId || ''}
      quote={
        <QuoteMessage message={raw} storeName={topBarInfo?.storeName} onQuoteClick={clickQuote} />
      }
      lazyScrollContainer={dialogRef?.dom}
    >
      {(component, status) => {
        if (status === 'success') {
          const result = (
            <MessageStatusDecorate
              message={raw}
              status={msg?.status}
              content={component}
              failCause={failCause}
              dialogRef={dialogRef}
            />
          );
          return <MessageExtend raw={raw} msg={msg} conversation={conversation} content={result} />;
        }
        // 如没有加载成功，不展示于界面上
        return null;
      }}
    </LazyItemMessage>
  );
});
